// services/routingGuidesService.js
import axiosInstance from './AxiosInstance';

const fetchRoutingGuides = async (searchParams = {}, page = 1, pageSize = 10, sortBy = "", order = "asc") => {
  const queryObj = { ...searchParams, page, pageSize };
  if (sortBy) {
    queryObj.sortBy = sortBy;
    queryObj.order = order;
  }

  try {
    const response = await axiosInstance.get('/routing-guides', {
      params: queryObj,
    });
    
    if (response.data?.data) {
      const guides = response.data.data.map((guide) => ({
        ...guide,
        id: guide.routing_guide_id,
      }));
      return {
        data: guides,
        totalRecords: response.data.totalRecords,
      };
    }
    throw new Error('Invalid data structure received from API');
  } catch (error) {
    console.error("Failed to fetch routing guides:", error);
    throw error;
  }
};

const SearchfetchRoutingGuides = async (guide_name) => {
  try {
    const response = await axiosInstance.get("/routing-guides?searchTerm=" + `${guide_name}`);
    if (response.data?.data) {
      const guides = response.data.data.map((guide) => ({
        ...guide,
        id: guide.routing_guide_id,
      }));
      return {
        data: guides,
        totalRecords: response.data.totalRecords,
      };
    }
  } catch (error) {
    console.error("Failed to fetch routing guides:", error);
    throw error;
  }
};



const createRoutingGuide = async (guideData) => {
  try {
    const response = await axiosInstance.post('/routing-guides', guideData);
    return response.data;
  } catch (error) {
    console.error("Error creating routing guide:", error);
    throw error;
  }
};

const updateRoutingGuide = async (guideId, guideData) => {
  try {
    const response = await axiosInstance.put(`/routing-guides/${guideId}`, guideData);
    return response.data;
  } catch (error) {
    console.error("Error updating routing guide:", error);
    throw error;
  }
};

const deleteRoutingGuide = async (guideId) => {
  try {
    const response = await axiosInstance.delete(`/routing-guides/${guideId}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting routing guide:", error);
    throw error;
  }
};

const fetchCommodityCodes = async (page=1, pageSize=100) => {
  try {

    const response = await axiosInstance.get('/commodityCode',
    {params: { page, pageSize, sortBy: "commodity_code" }},
    );
    
    if (response.data?.data && Array.isArray(response.data.data)) {
      return response.data.data;
    }
    throw new Error('Invalid commodity codes data structure');
  } catch (error) {
    console.error("Error fetching commodity codes:", error);
    throw error;
  }
};

const fetchDivisions = async () => {
  try {
    const response = await axiosInstance.get('/division');
    
    if (response.data?.data && Array.isArray(response.data.data)) {
      return response.data.data;
    }
    throw new Error('Invalid commodity codes data structure');
  } catch (error) {
    console.error("Error fetching commodity codes:", error);
    throw error;
  }
};
const fetchDc = async () => {
  try {
    const response = await axiosInstance.get('/distributionCenter');
    
    if (response.data?.data && Array.isArray(response.data.data)) {
      return response.data.data;
    }
    throw new Error('Invalid distribution Center  data structure');
  } catch (error) {
    console.error("Error fetching distribution Center:", error);
    throw error;
  }
};


export {
  fetchRoutingGuides,
  createRoutingGuide,
  updateRoutingGuide,
  deleteRoutingGuide,
  fetchCommodityCodes,
  fetchDivisions,
  fetchDc,
  SearchfetchRoutingGuides
};